<template>
  <div>
    <div class="cw-sunstudy-controls">
      <h3 class="sunstudy-heading">Solstudie</h3>
      <p class="sunstudy-text">Dra i reglaget för att välja tid på dygnet</p>
      <div class="cw-sunstudy-controls-top">
        <div class="c-icon"><span class="icon icon-sun"></span></div>
        <div class="c-time-label">kl</div>
        <div class="sunstudy-time-cols">
          <div v-for="col in cols" :class="col.className" @click="onHourClick(col)">{{col.label}}</div>
          <div class="sunstudy-current-hour">{{currentHour}}</div>
        </div>
        <div class="c-view-buttons">
          <button class="btn" v-for="v in sunstudy.views.data" @click="changeView(v)"
                  :class="{'active': v.id === view.id}">{{v.name}}
          </button>
        </div>
      </div>

      <div class="cw-sunstudy-controls-bottom">
        <div class="cw-sunstudy-controls-slider">
          <div :class="'fake-slider fake-slider-w-' + offsetLeft">
            <div class="slider-rail"></div>
          </div>
          <vue-slider :minx="1" :max="view.image_count-1" v-model="currentFrame"
                      :height="1"
                      :real-time="true"
                      :tooltip="false"
                      :dot-width="30"
                      :dot-height="8"
                      ref="slider"
                      class="cw-sunstudy-slider real-slider"></vue-slider>

          <!--<Slider min={1}   max={this.state.nImages}   onChange={this.onSlide} value={this.props.currentSlide}
                  class="real-slider cw-sunstudy-slider"/>-->

          <div :class="'fake-slider fake-slider-w-' + offsetRight">
            <div class="slider-rail"></div>
          </div>
        </div>
      </div>

      <div>

      </div>
    </div>
  </div>
</template>

<script>
  import vueSlider from 'vue-slider-component'
  import {pad} from '../../functions'

  export default {
    name: 'SunstudyControls',
    props: ['sunstudy', 'view', 'slide'],
    data () {
      return {
        currentFrame: null,
        fakeSliderLeftWidth: 10,
        fakeSliderRightWidth: 10
      }
    },
    watch: {
      currentFrame () {
        this.$emit('slide', this.currentFrame)
      },
      view () {
        this.init()
      }
    },
    created () {
      this.init()
    },
    computed: {
      offsetLeft () {
        return this.view.start_hour - 1
      },
      offsetRight () {
        return 24 - this.view.end_hour
      },
      step () {
        const hours = this.view.end_hour - this.view.start_hour
        return this.view.image_count / hours
      },
      currentHour () {
        return Math.round(this.currentFrame / (this.step)) + this.view.start_hour
      },
      cols () {
        let cols = []
        for (let i = 1; i <= 24; i++) {
          cols.push({
            key: i,
            time: i,
            className: i < this.view.start_hour || i > this.view.end_hour ? 'time-col disabled' : 'time-col',
            label: pad('00', i, true)
          })
        }
        return cols
      }
    },
    methods: {
      onHourClick (hour) {
        const slide = Math.round(hour.time * this.step)
        this.$emit('slide', slide)
      },
      init () {
        this.currentFrame = this.view.start_frame
        if (this.$refs['slider']) {
          this.$nextTick(() => {
            this.$refs['slider'].refresh()
          })
        }
      },
      changeView (view) {
        this.$emit('view', view)
      }
    },
    components: {
      vueSlider
    }
  }
</script>

<style lang="scss">
  @import '~bootstrap/scss/functions';
  @import '~bootstrap/scss/variables';
  @import '~bootstrap/scss/mixins';

  $time-col-width: 20px;
  $time-col-width-xl: 20px;

  .cw-sunstudy-controls {
    padding-left: 15px;
    padding-right: 15px;
  }

  .sunstudy-text {
    margin: 0 0 10px 0;
    font-size: 12px;

    @include media-breakpoint-up(sm) {
      font-size: 16px;
    }
  }

  .sunstudy-heading {
    margin: 0 0 5px 0;
    font-weight: normal;
    font-size: 16px;

    @include media-breakpoint-up(sm) {
      font-size: 16px;
    }
  }

  .vue-slider-component.cw-sunstudy-slider {
    padding: 0 !important;

    .vue-slider {
      border-radius: 0;
    }

    .vue-slider-dot {
      border-radius: 0;
      box-shadow: none;
      background: #eee;
    }

    .vue-slider-process, .vue-slider {
      background: #000;
    }
  }

  .cw-sunstudy-controls-top,
  .cw-sunstudy-controls-bottom {
    display: flex;
    flex-direction: row;
  }

  .sunstudy-time-cols {
    display: flex;
    flex-direction: row;
    width: 40px;
    font-size: 12px;

    .time-col {
      text-align: center;
      flex: 0 0 20px;
      font-size: 12px;
      padding: 2px 2px;

      &.disabled {
        color: #ddd;
      }
    }
  }

  .cw-sunstudy-controls-top {
    align-items: center;
    line-height: 30px;
    margin-bottom: 10px;

    .c-icon {
      flex: 0 0 30px;
      text-align: center;
      font-size: 24px;
    }

    .c-time-label {
      flex: 0 0 20px;
      text-align: center;
      font-size: 12px;
    }

    .c-view-buttons {
      flex: 1;
      text-align: right;
    }
  }

  .sunstudy-current-hour {
    display: none;
  }

  // Mobile
  @include media-breakpoint-down(sm) {
    .sunstudy-time-cols .time-col {
      display: none;
    }

    .sunstudy-current-hour {
      display: block;
      font-weight: bold;
      padding-left: 10px;
    }
  }

  .cw-sunstudy-controls-bottom {
    .cw-sunstudy-controls-slider {

      width: 480px;
      display: flex;
      padding-left: 5px;
      padding-right: 5px;

      @include media-breakpoint-up(md) {
        margin-left: 50px;
      }
    }

    .fake-slider {
      flex: 0 0 auto;
    }

    .real-slider {
      flex: 1 0 auto;
      z-index: 10;
    }
  }

  .slider-rail {
    height: 1px;
    background-color: #ccc;
  }

  @include media-breakpoint-up(xl) {
    body {
    }
    .cw-sunstudy-controls-bottom .cw-sunstudy-controls-slider {
      width: 24*$time-col-width;
    }

    .cw-sunstudy-controls-top {
      .time-cols {
        width: 24*$time-col-width-xl;

        .time-col {
          width: $time-col-width-xl;
          flex: 0 0 $time-col-width-xl;
        }
      }
    }
  }

  @include media-breakpoint-up(xl) {
    .cw-sunstudy-controls-bottom .cw-sunstudy-controls-slider {
      width: 24*$time-col-width-xl;
    }

    .cw-sunstudy-controls-top {
      .time-cols {
        width: 24*$time-col-width-xl;

        .time-col {
          width: $time-col-width-xl;
          flex: 0 0 $time-col-width-xl;
        }
      }
    }
  }

  @for $i from 1 through 23 {
    .cw-sunstudy-controls-bottom .fake-slider-w-#{$i} {
      width: $i*20px + 5px;

      @include media-breakpoint-down(sm) {
        width: 15px;
      }
    }

    /*@include media-breakpoint-up(lg) {
      .cw-sunstudy-controls-bottom .fake-slider-w-#{$i} {
        width: $i*20px + 7px;
      }
    }

    @include media-breakpoint-up(xxl) {
      .cw-sunstudy-controls-bottom .fake-slider-w-#{$i} {
        width: $i*$time-col-width-xl + 10px;

      }
    }*/
  }

</style>



// WEBPACK FOOTER //
// src/components/Partials/SunstudyControls.vue